export default "__VITE_ASSET__BWcziaPi__"